import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, locationValidations } from "./location-schema";
import { createLocation } from "services/data.internal.service";
import LocationInfo from "./components/LocationInfo";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useLocation } from "react-router-dom";
import { useCustomerValue } from "providers/CustomerContext";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useLocationGroupOptionsQuery } from "hooks/useLocationQuery";

function AddLocation() {
  const location = useLocation();
  const { warehouseCode: whCode = null, zoneID = null } = location?.state ?? {};
  const {customerCode}=useCustomerValue()

  const [alert, setAlert] = useState(null);
  const [whOptions, setWhOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [locDimGrpOptions, setLocDimGrpOptions] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createLocationMutation = useMutation(createLocation, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: { ...initialValues, warehouseCode: whCode, zoneID },
    resolver: yupResolver(locationValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = form;

  const [warehouseCode, locCategory] = watch(["warehouseCode", "locCategory"]);

  useEffect(() => {
    if (locCategory === null) {
      setValue("dropZone", null);
    }
  }, [locCategory]);

  useCustWhOptionsQuery({customerCode,onSuccess: (data) => setWhOptions(data.data.data)});

  useZoneOptionsQuery({
    whCode: warehouseCode,
    onSuccess: (data) => setZoneOptions(data.data.data),
  });

  useLocationGroupOptionsQuery({
    onSuccess: (data) => setLocDimGrpOptions(data.data.data),
  })

  const infoProps = {
    values: { locCategory },
    whOptions,
    zoneOptions,
    getValues,
    control,
    errors,
    setValue,
    formRender,
    locDimGrpOptions,
  };
  const onSubmit = (data) => createLocationMutation.mutate(data, {onSuccess: () => reset()});
  
  const createStatus = createLocationMutation.status === "loading"
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <LocationInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus} url="/setup/location" />
      </form>
    </Layout>
  );
}

export default AddLocation;
